module.exports = __webpack_public_path__ + "assets/img/welfare-img2-d8e336c5.jpg";